(function () {
  const SELECTORS = {
    cartDrawer: '[data-bod-cart-drawer]',
    cartOverlay: '[data-bod-cart-overlay]',
    cartBody: '[data-bod-cart-body]',
    cartSubtotal: '[data-bod-cart-subtotal]',
    cartCount: '[data-bod-cart-count]',
    cartShip: '[data-bod-cart-ship]',
    cartShipMsg: '[data-bod-cart-ship-msg]',
    cartShipFill: '[data-bod-cart-ship-fill]',
    openCart: '[data-bod-cart-open]',
    closeCart: '[data-bod-cart-close]',
    addButton: '[data-bod-add]',
    burger: '[data-bod-burger]',
    mobileNav: '[data-bod-mobilenav]',
    mobileQuickAddOpen: '[data-bod-mobile-quickadd-open]',
    mobileQuickAddClose: '[data-bod-mobile-quickadd-close]',
    mobileVariantButton: '[data-bod-mobile-variant-id]',
    mobileQuickAddAtc: '[data-bod-mobile-quickadd-atc]'
  };

  function getUpsellCollectionHandle() {
    const drawer = getDrawer();

    return drawer?.getAttribute('data-upsell-collection') || 'best-sellers';
  }

  function getUpsellLimit() {
    const drawer = getDrawer();
    const value = Number(drawer?.getAttribute('data-upsell-limit') || 3);

    return Number.isFinite(value) && value > 0 ? value : 3;
  }

  let bodSelectedMobileVariantId = null;

  function money(cents) {
    const amount = (cents || 0) / 100;

    return amount.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD'
    });
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function getDrawer() {
    return document.querySelector(SELECTORS.cartDrawer);
  }

  function getFreeShippingGoal() {
    const drawer = getDrawer();

    if (!drawer) return 0;

    const value = Number(drawer.getAttribute('data-free-threshold') || 0);

    return Number.isFinite(value) ? value : 0;
  }

  function ensureBodCartOverlay() {
    let overlay = document.querySelector(SELECTORS.cartOverlay);

    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'bod-cart-overlay';
      overlay.setAttribute('data-bod-cart-overlay', '');
      overlay.setAttribute('data-bod-cart-close', '');
      document.body.appendChild(overlay);
    }

    return overlay;
  }

  function openBodCart() {
    const drawer = getDrawer();
    const overlay = ensureBodCartOverlay();

    closeBodMobileMenu();
    closeBodMobileQuickAdd();

    if (drawer) {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
    }

    overlay.classList.add('is-open');
    document.body.classList.add('bod-cart-open');

    refreshCart();
  }

  function closeBodCart() {
    const drawer = getDrawer();
    const overlay = document.querySelector(SELECTORS.cartOverlay);

    if (drawer) {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
    }

    if (overlay) {
      overlay.classList.remove('is-open');
    }

    document.body.classList.remove('bod-cart-open');
  }

  async function fetchCart() {
    const response = await fetch('/cart.js', {
      method: 'GET',
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Could not fetch cart.');
    }

    return response.json();
  }

  async function addToCart(variantId, quantity = 1) {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: Number(quantity)
      })
    });

    if (!response.ok) {
      throw new Error('Could not add item to cart.');
    }

    return response.json();
  }

  async function changeCartItem(line, quantity) {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        line: Number(line),
        quantity: Number(quantity)
      })
    });

    if (!response.ok) {
      throw new Error('Could not update cart.');
    }

    return response.json();
  }

  async function fetchUpsellProducts() {
    const collectionHandle = getUpsellCollectionHandle();

    const response = await fetch(
      `/collections/${encodeURIComponent(collectionHandle)}/products.json?limit=12`,
      {
        method: 'GET',
        headers: {
          Accept: 'application/json'
        }
      }
    );

    if (!response.ok) {
      throw new Error('Could not fetch upsell products.');
    }

    const data = await response.json();

    return data.products || [];
  }

  function getProductImage(product) {
    if (product.images && product.images.length && product.images[0].src) {
      return product.images[0].src;
    }

    if (product.image && product.image.src) {
      return product.image.src;
    }

    return '';
  }

  function getProductPrice(product) {
    if (!product.variants || !product.variants.length) return '$0.00';

    const price = Number(product.variants[0].price || 0);

    return price.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD'
    });
  }

  function ensureUpsellBlock() {
    const drawer = getDrawer();

    if (!drawer) return null;

    let upsell = drawer.querySelector('[data-bod-cart-upsell]');

    if (upsell) return upsell;

    upsell = document.createElement('div');
    upsell.className = 'bod-cart-reco';
    upsell.setAttribute('data-bod-cart-upsell', '');

    upsell.innerHTML = `
      <div class="bod-cart-reco-title">YOU MAY ALSO LIKE</div>
      <div class="bod-cart-reco-track" data-bod-cart-reco-track></div>
    `;

    const foot = drawer.querySelector('.bod-cart-foot');

    if (foot) {
      drawer.insertBefore(upsell, foot);
    } else {
      drawer.appendChild(upsell);
    }

    return upsell;
  }

  async function renderUpsells(cart) {
    const upsell = ensureUpsellBlock();

    if (!upsell) return;

    const track = upsell.querySelector('[data-bod-cart-reco-track]');

    if (!track) return;

    try {
      const products = await fetchUpsellProducts();

      const cartProductHandles = (cart.items || [])
        .map(function (item) {
          if (!item.url) return '';

          const parts = item.url.split('/products/');
          return parts[1] ? parts[1].split('?')[0].replace('/', '') : '';
        })
        .filter(Boolean);

      const filteredProducts = products
        .filter(function (product) {
          return !cartProductHandles.includes(product.handle);
        })
        .slice(0, getUpsellLimit());

      if (!filteredProducts.length) {
        upsell.style.display = 'none';
        return;
      }

      upsell.style.display = '';

      function sizeOptionIndex(product) {
        const opts = product.options || [];

        for (let i = 0; i < opts.length; i++) {
          const name = typeof opts[i] === 'string' ? opts[i] : opts[i] && opts[i].name;
          if (name && String(name).toLowerCase().indexOf('size') !== -1) return i;
        }

        return -1;
      }

      function sizeLabel(product, variant, idx) {
        if (idx >= 0 && variant['option' + (idx + 1)]) {
          return variant['option' + (idx + 1)];
        }

        if (variant.title && variant.title !== 'Default Title') {
          const parts = variant.title.split(' / ');
          return parts[parts.length - 1];
        }

        return 'OS';
      }

      track.innerHTML = filteredProducts
        .map(function (product) {
          const image = getProductImage(product);
          const price = getProductPrice(product);
          const handle = escapeHtml(product.handle);
          const title = escapeHtml(product.title).toUpperCase();
          const variants = product.variants || [];
          const idx = sizeOptionIndex(product);

          let controls;

          if (variants.length <= 1) {
            const v = variants[0];
            const avail = v && v.available;

            controls = `
              <div class="bod-cart-reco-sizes">
                <button
                  type="button"
                  class="bod-cart-reco-size bod-cart-reco-size--single"
                  data-bod-add
                  data-variant-id="${v ? v.id : ''}"
                  ${avail ? '' : 'disabled aria-disabled="true"'}
                >${avail ? 'ADD' : 'SOLD OUT'}</button>
              </div>
            `;
          } else {
            controls = `
              <div class="bod-cart-reco-sizes">
                ${variants
                  .map(function (v) {
                    const label = escapeHtml(sizeLabel(product, v, idx));

                    return `
                      <button
                        type="button"
                        class="bod-cart-reco-size"
                        data-bod-add
                        data-variant-id="${v.id}"
                        aria-label="Add size ${label}"
                        ${v.available ? '' : 'disabled aria-disabled="true"'}
                      >${label}</button>
                    `;
                  })
                  .join('')}
              </div>
            `;
          }

          return `
            <div class="bod-cart-reco-card">
              <a class="bod-cart-reco-card-img" href="/products/${handle}" aria-label="${title}">
                ${
                  image
                    ? `<img src="${escapeHtml(image)}" alt="${escapeHtml(product.title)}" loading="lazy">`
                    : `<span class="bod-ph"></span>`
                }
              </a>
              <a class="bod-cart-reco-card-link" href="/products/${handle}">
                <h5>${title}</h5>
              </a>
              <p class="bod-cart-reco-price">${price}</p>
              ${controls}
            </div>
          `;
        })
        .join('');
    } catch (error) {
      console.error(error);
      upsell.style.display = 'none';
    }
  }

  function renderCart(cart) {
    const body = document.querySelector(SELECTORS.cartBody);
    const subtotal = document.querySelector(SELECTORS.cartSubtotal);
    const countEls = document.querySelectorAll(SELECTORS.cartCount);
    const ship = document.querySelector(SELECTORS.cartShip);
    const shipMsg = document.querySelector(SELECTORS.cartShipMsg);
    const shipFill = document.querySelector(SELECTORS.cartShipFill);

    if (!body) return;

    if (!cart.items || cart.items.length === 0) {
      body.innerHTML = '<div class="bod-cart-empty">YOUR CART IS EMPTY</div>';
    } else {
      body.innerHTML = cart.items
        .map(function (item, index) {
          const image = item.image
            ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.product_title)}" loading="lazy">`
            : `<span class="bod-ph"></span>`;

          const variant =
            item.variant_title && item.variant_title !== 'Default Title'
              ? `<div class="bod-cart-item-variant">${escapeHtml(item.variant_title)}</div>`
              : '';

          return `
            <div class="bod-cart-item">
              <a class="bod-cart-item-img" href="${escapeHtml(item.url)}">
                ${image}
              </a>

              <div class="bod-cart-item-info">
                <h4>${escapeHtml(item.product_title)}</h4>
                ${variant}

                <div class="bod-cart-qty">
                  <button type="button" data-bod-cart-qty data-line="${index + 1}" data-qty="${item.quantity - 1}">−</button>
                  <span>${item.quantity}</span>
                  <button type="button" data-bod-cart-qty data-line="${index + 1}" data-qty="${item.quantity + 1}">+</button>
                </div>
              </div>

              <div class="bod-cart-item-right">
                <div class="bod-cart-item-price">${money(item.final_line_price)}</div>
                <button type="button" class="bod-cart-item-remove" data-bod-cart-qty data-line="${index + 1}" data-qty="0">
                  REMOVE
                </button>
              </div>
            </div>
          `;
        })
        .join('');
    }

    if (subtotal) {
      subtotal.textContent = money(cart.total_price);
    }

    countEls.forEach(function (el) {
      el.textContent = cart.item_count || 0;
    });

    const freeShippingGoal = getFreeShippingGoal();

    if (!freeShippingGoal || freeShippingGoal <= 0) {
      if (ship) ship.hidden = true;
    } else {
      if (ship) ship.hidden = false;

      const remaining = Math.max(freeShippingGoal - cart.total_price, 0);
      const progress = Math.min((cart.total_price / freeShippingGoal) * 100, 100);

      if (shipMsg) {
        if (remaining > 0) {
          shipMsg.innerHTML = `YOU ARE <b>${money(remaining)}</b> AWAY FROM FREE SHIPPING`;
        } else {
          shipMsg.innerHTML = `<b>FREE SHIPPING UNLOCKED</b>`;
        }
      }

      if (shipFill) {
        shipFill.style.width = `${progress}%`;
      }
    }

    renderUpsells(cart);
  }

  async function refreshCart() {
    try {
      const cart = await fetchCart();
      renderCart(cart);
    } catch (error) {
      console.error(error);
    }
  }

  function closeBodMobileMenu() {
    const burger = document.querySelector(SELECTORS.burger);
    const mobileNav = document.querySelector(SELECTORS.mobileNav);

    if (burger) {
      burger.classList.remove('is-open');
      burger.setAttribute('aria-expanded', 'false');
    }

    if (mobileNav) {
      mobileNav.classList.remove('open');
    }

    document.body.classList.remove('bod-menu-open');
  }

  function initBodMobileMenu() {
    const burger = document.querySelector(SELECTORS.burger);
    const mobileNav = document.querySelector(SELECTORS.mobileNav);

    if (!burger || !mobileNav || burger.dataset.bodReady === 'true') return;

    burger.dataset.bodReady = 'true';
    burger.setAttribute('aria-expanded', burger.classList.contains('is-open') ? 'true' : 'false');

    burger.addEventListener('click', function (event) {
      event.preventDefault();

      const isOpen = burger.classList.toggle('is-open');

      if (isOpen) {
        setBodMobileQuickAddTop();
      }

      mobileNav.classList.toggle('open', isOpen);
      burger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      document.body.classList.toggle('bod-menu-open', isOpen);

      if (isOpen) {
        closeBodCart();
        closeBodMobileQuickAdd();
      }
    });

    mobileNav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', closeBodMobileMenu);
    });
  }

  function setBodMobileQuickAddTop() {
    const header = document.querySelector('.bod .bod-header');
    const top = header ? Math.round(header.getBoundingClientRect().bottom) : 58;

    document.documentElement.style.setProperty(
      '--bod-mobile-qa-top',
      `${Math.max(top, 0)}px`
    );
  }

  function ensureBodMobileQuickAddDrawer() {
    let overlay = document.querySelector('[data-bod-mobile-quickadd-overlay]');
    let drawer = document.querySelector('[data-bod-mobile-quickadd]');

    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'bod-mobile-quickadd-overlay';
      overlay.setAttribute('data-bod-mobile-quickadd-overlay', '');
      overlay.setAttribute('data-bod-mobile-quickadd-close', '');
      document.body.appendChild(overlay);
    }

    if (!drawer) {
      drawer = document.createElement('div');
      drawer.className = 'bod-mobile-quickadd';
      drawer.setAttribute('data-bod-mobile-quickadd', '');

      drawer.innerHTML = `
        <button type="button" class="bod-mobile-quickadd-close" data-bod-mobile-quickadd-close aria-label="Close quick add">&times;</button>

        <div class="bod-mobile-quickadd-gallery" data-bod-mobile-quickadd-gallery></div>

        <div class="bod-mobile-quickadd-info">
          <h3 data-bod-mobile-quickadd-title></h3>
          <p class="bod-mobile-quickadd-price" data-bod-mobile-quickadd-price></p>

          <div class="bod-mobile-quickadd-color-row" data-bod-mobile-quickadd-color-row style="display:none">
            <span class="bod-mobile-quickadd-label">COLOR</span>
          </div>

          <div class="bod-mobile-quickadd-colors" data-bod-mobile-quickadd-colors></div>

          <div class="bod-mobile-quickadd-size-row">
            <span class="bod-mobile-quickadd-label">SIZE</span>
            <a href="#" class="bod-mobile-quickadd-size-help">WHAT'S MY SIZE?</a>
          </div>

          <div class="bod-mobile-quickadd-sizes" data-bod-mobile-quickadd-sizes></div>

          <button type="button" class="bod-mobile-quickadd-atc" data-bod-mobile-quickadd-atc disabled>
            ADD TO CART
          </button>

          <a class="bod-mobile-quickadd-details" href="#" data-bod-mobile-quickadd-details>
            VIEW FULL DETAILS
          </a>
        </div>
      `;

      document.body.appendChild(drawer);
    }

    return { overlay, drawer };
  }

  function getMobileVariantLabel(variant) {
    if (!variant || !variant.title) return '';

    if (variant.title === 'Default Title') return 'OS';

    const parts = variant.title.split(' / ');

    if (parts.length > 1) {
      return parts[parts.length - 1];
    }

    return variant.title;
  }

  function applyMobileColor(drawer, color) {
    drawer._bodColor = color;
    const variants = drawer._bodVariants || [];

    drawer.querySelectorAll('[data-bod-mobile-color]').forEach(function (btn) {
      btn.classList.toggle(
        'is-active',
        btn.getAttribute('data-bod-mobile-color') === color
      );
    });

    drawer.querySelectorAll('[data-bod-mobile-size]').forEach(function (btn) {
      const sz = btn.getAttribute('data-bod-mobile-size');
      const match = variants.find(function (v) {
        return v.color === color && v.size === sz;
      });

      btn.classList.remove('is-active');

      if (match && match.available) {
        btn.disabled = false;
        btn.setAttribute('aria-disabled', 'false');
        btn.setAttribute('data-bod-mobile-variant-id', match.id);
      } else {
        btn.disabled = true;
        btn.setAttribute('aria-disabled', 'true');
        btn.removeAttribute('data-bod-mobile-variant-id');
      }
    });

    bodSelectedMobileVariantId = null;

    const atc = drawer.querySelector('[data-bod-mobile-quickadd-atc]');

    if (atc) {
      atc.disabled = true;
      atc.textContent = 'ADD TO CART';
    }
  }

  function openBodMobileQuickAdd(button) {
    const card = button.closest('.bod-card');

    if (!card) return;

    const structuredScript = card.querySelector('[data-bod-variants]');
    const rawScript = card.querySelector('[data-bod-product-variants]');
    const variantsScript = structuredScript || rawScript;

    if (!variantsScript) return;

    let variants = [];

    try {
      variants = JSON.parse(variantsScript.textContent || '[]');
    } catch (error) {
      console.error(error);
      return;
    }

    const isStructured = variants.length > 0 && 'size' in variants[0];

    const colors = [];
    const sizes = [];

    if (isStructured) {
      variants.forEach(function (v) {
        if (v.color && colors.indexOf(v.color) === -1) colors.push(v.color);
        if (v.size && sizes.indexOf(v.size) === -1) sizes.push(v.size);
      });
    }

    const { overlay, drawer } = ensureBodMobileQuickAddDrawer();

    setBodMobileQuickAddTop();

    const title = button.getAttribute('data-product-title') || '';
    const url = button.getAttribute('data-product-url') || '#';
    const price = button.getAttribute('data-product-price') || '';
    const fallbackImage = button.getAttribute('data-product-image') || '';

    let images = [];

    try {
      images = JSON.parse(button.getAttribute('data-product-images') || '[]');
    } catch (error) {
      images = fallbackImage ? [fallbackImage] : [];
    }

    if (!images.length && fallbackImage) {
      images = [fallbackImage];
    }

    bodSelectedMobileVariantId = null;

    const titleEl = drawer.querySelector('[data-bod-mobile-quickadd-title]');
    const priceEl = drawer.querySelector('[data-bod-mobile-quickadd-price]');
    const galleryEl = drawer.querySelector('[data-bod-mobile-quickadd-gallery]');
    const colorRow = drawer.querySelector('[data-bod-mobile-quickadd-color-row]');
    const colorsEl = drawer.querySelector('[data-bod-mobile-quickadd-colors]');
    const sizesEl = drawer.querySelector('[data-bod-mobile-quickadd-sizes]');
    const atcBtn = drawer.querySelector('[data-bod-mobile-quickadd-atc]');
    const detailsLink = drawer.querySelector('[data-bod-mobile-quickadd-details]');

    if (titleEl) titleEl.textContent = title;
    if (priceEl) priceEl.textContent = price;
    if (detailsLink) detailsLink.setAttribute('href', url);

    if (galleryEl) {
      galleryEl.innerHTML = images
        .map(function (src) {
          return `
            <div class="bod-mobile-quickadd-gallery-item">
              <img src="${escapeHtml(src)}" alt="${escapeHtml(title)}" loading="lazy">
            </div>
          `;
        })
        .join('');
    }

    if (atcBtn) {
      atcBtn.disabled = true;
      atcBtn.textContent = 'ADD TO CART';
    }

    // Stash variant data + selection state on the drawer for the click handlers.
    drawer._bodVariants = variants;
    drawer._bodStructured = isStructured;
    drawer._bodColor = null;

    // COLOR row: only when structured AND more than one color exists.
    if (isStructured && colors.length > 1 && colorsEl && colorRow) {
      colorRow.style.display = '';
      colorsEl.style.display = '';
      colorsEl.innerHTML = colors
        .map(function (c) {
          const hasStock = variants.some(function (v) {
            return v.color === c && v.available;
          });

          return `
            <button
              type="button"
              class="bod-mobile-quickadd-color"
              data-bod-mobile-color="${escapeHtml(c)}"
              ${hasStock ? '' : 'disabled aria-disabled="true"'}
            >
              ${escapeHtml(c)}
            </button>
          `;
        })
        .join('');
    } else {
      if (colorRow) colorRow.style.display = 'none';
      if (colorsEl) {
        colorsEl.style.display = 'none';
        colorsEl.innerHTML = '';
      }
    }

    // SIZE row.
    if (sizesEl) {
      if (isStructured) {
        sizesEl.innerHTML = sizes
          .map(function (sz) {
            return `
              <button
                type="button"
                class="bod-mobile-quickadd-size"
                data-bod-mobile-size="${escapeHtml(sz)}"
                disabled
                aria-disabled="true"
              >
                ${escapeHtml(sz)}
              </button>
            `;
          })
          .join('');

        // Single-color products: auto-select that color so sizes light up.
        if (colors.length === 1) {
          drawer._bodColor = colors[0];
        }
      } else {
        // Fallback: original raw behavior (one button per variant).
        sizesEl.innerHTML = variants
          .map(function (variant) {
            const label = getMobileVariantLabel(variant);

            return `
              <button
                type="button"
                class="bod-mobile-quickadd-size"
                data-bod-mobile-variant-id="${variant.id}"
                ${variant.available ? '' : 'disabled aria-disabled="true"'}
              >
                ${escapeHtml(label)}
              </button>
            `;
          })
          .join('');
      }
    }

    // If a single color was auto-selected, enable its sizes immediately.
    if (isStructured && drawer._bodColor) {
      applyMobileColor(drawer, drawer._bodColor);
    }

    overlay.classList.add('is-open');
    drawer.classList.add('is-open');
    document.body.classList.add('bod-mobile-quickadd-open');

    closeBodCart();
    closeBodMobileMenu();
  }

  function closeBodMobileQuickAdd() {
    const overlay = document.querySelector('[data-bod-mobile-quickadd-overlay]');
    const drawer = document.querySelector('[data-bod-mobile-quickadd]');

    if (overlay) {
      overlay.classList.remove('is-open');
    }

    if (drawer) {
      drawer.classList.remove('is-open');
    }

    document.body.classList.remove('bod-mobile-quickadd-open');
    bodSelectedMobileVariantId = null;
  }

  function initVariantPickers() {
    document.querySelectorAll('[data-bod-variants]').forEach(function (script) {
      const quickAdd = script.closest('.bod-quickadd');

      if (!quickAdd || quickAdd.dataset.bodVariantsReady === 'true') return;

      quickAdd.dataset.bodVariantsReady = 'true';

      let variants = [];

      try {
        variants = JSON.parse(script.textContent || '[]');
      } catch (error) {
        console.error(error);
        return;
      }

      const swatches = quickAdd.querySelectorAll('[data-bod-swatch]');
      const sizeButtons = quickAdd.querySelectorAll('[data-bod-add][data-size]');

      function selectColor(color) {
        let activeSwatch = null;

        swatches.forEach(function (swatch) {
          const isActive = swatch.getAttribute('data-color') === color;

          swatch.classList.toggle('is-active', isActive);

          if (isActive) {
            activeSwatch = swatch;
          }
        });

        const card = quickAdd.closest('.bod-card');

        if (card && activeSwatch) {
          const imageUrl = activeSwatch.getAttribute('data-image');

          if (imageUrl) {
            const image = card.querySelector('.bod-card-media img');

            if (image) {
              image.src = imageUrl;
              image.srcset = '';
            }

            const mobileButton = card.querySelector('[data-bod-mobile-quickadd-open]');

            if (mobileButton) {
              mobileButton.setAttribute('data-product-image', imageUrl);
            }
          }
        }

        sizeButtons.forEach(function (btn) {
          const size = btn.getAttribute('data-size');
          const variant = variants.find(function (item) {
            return item.color === color && item.size === size;
          });

          if (!variant) {
            btn.disabled = true;
            btn.setAttribute('aria-disabled', 'true');
            btn.removeAttribute('data-variant-id');
            return;
          }

          btn.setAttribute('data-variant-id', variant.id);

          if (variant.available) {
            btn.disabled = false;
            btn.setAttribute('aria-disabled', 'false');
          } else {
            btn.disabled = true;
            btn.setAttribute('aria-disabled', 'true');
          }
        });
      }

      swatches.forEach(function (swatch) {
        swatch.addEventListener('click', function () {
          selectColor(swatch.getAttribute('data-color'));
        });
      });

      if (swatches.length) {
        selectColor(swatches[0].getAttribute('data-color'));
      }
    });
  }

  document.addEventListener('click', async function (event) {
    const openButton = event.target.closest(SELECTORS.openCart);
    const closeButton = event.target.closest(SELECTORS.closeCart);
    const addButton = event.target.closest(SELECTORS.addButton);
    const qtyButton = event.target.closest('[data-bod-cart-qty]');

    const mobileQuickAddButton = event.target.closest(SELECTORS.mobileQuickAddOpen);
    const mobileQuickAddClose = event.target.closest(SELECTORS.mobileQuickAddClose);
    const mobileColorButton = event.target.closest('[data-bod-mobile-color]');
    const mobileSizeButton = event.target.closest(SELECTORS.mobileVariantButton);
    const mobileAtcButton = event.target.closest(SELECTORS.mobileQuickAddAtc);

    if (mobileQuickAddButton) {
      event.preventDefault();
      openBodMobileQuickAdd(mobileQuickAddButton);
      return;
    }

    if (mobileQuickAddClose) {
      event.preventDefault();
      closeBodMobileQuickAdd();
      return;
    }

    if (mobileColorButton) {
      event.preventDefault();

      const drawer = document.querySelector('[data-bod-mobile-quickadd]');

      if (!drawer || mobileColorButton.disabled) return;

      applyMobileColor(
        drawer,
        mobileColorButton.getAttribute('data-bod-mobile-color')
      );

      return;
    }

    if (mobileSizeButton) {
      event.preventDefault();

      const drawer = document.querySelector('[data-bod-mobile-quickadd]');

      if (!drawer || mobileSizeButton.disabled) return;

      drawer.querySelectorAll(SELECTORS.mobileVariantButton).forEach(function (btn) {
        btn.classList.remove('is-active');
      });

      mobileSizeButton.classList.add('is-active');
      bodSelectedMobileVariantId = mobileSizeButton.getAttribute('data-bod-mobile-variant-id');

      const atcBtn = drawer.querySelector(SELECTORS.mobileQuickAddAtc);

      if (atcBtn) {
        atcBtn.disabled = false;
      }

      return;
    }

    if (mobileAtcButton) {
      event.preventDefault();

      if (!bodSelectedMobileVariantId || mobileAtcButton.disabled) return;

      mobileAtcButton.disabled = true;
      mobileAtcButton.textContent = 'ADDING...';

      try {
        await addToCart(bodSelectedMobileVariantId, 1);
        await refreshCart();
        closeBodMobileQuickAdd();
        openBodCart();
      } catch (error) {
        console.error(error);
        mobileAtcButton.disabled = false;
        mobileAtcButton.textContent = 'ADD TO CART';
      }

      return;
    }

    if (openButton) {
      event.preventDefault();
      openBodCart();
      return;
    }

    if (closeButton) {
      event.preventDefault();
      closeBodCart();
      return;
    }

    if (addButton) {
      event.preventDefault();

      const variantId = addButton.getAttribute('data-variant-id');

      if (!variantId || addButton.disabled) return;

      addButton.classList.add('is-loading');

      try {
        await addToCart(variantId, 1);
        await refreshCart();
        openBodCart();
      } catch (error) {
        console.error(error);
      } finally {
        addButton.classList.remove('is-loading');
      }

      return;
    }

    if (qtyButton) {
      event.preventDefault();

      const line = qtyButton.getAttribute('data-line');
      const qty = qtyButton.getAttribute('data-qty');

      if (!line || qty === null) return;

      qtyButton.disabled = true;

      try {
        const cart = await changeCartItem(line, qty);
        renderCart(cart);
      } catch (error) {
        console.error(error);
      }

      return;
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    closeBodMobileQuickAdd();
    closeBodCart();
    closeBodMobileMenu();
  });

  window.addEventListener('resize', function () {
    if (document.body.classList.contains('bod-mobile-quickadd-open')) {
      setBodMobileQuickAddTop();
    }
  });

  window.addEventListener(
    'scroll',
    function () {
      if (document.body.classList.contains('bod-mobile-quickadd-open')) {
        setBodMobileQuickAddTop();
      }
    },
    { passive: true }
  );

  function initBod() {
    initBodMobileMenu();
    initVariantPickers();
    refreshCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBod);
  } else {
    initBod();
  }

  function resetBodOpenStates() {
    const drawer = document.querySelector(SELECTORS.cartDrawer);
    const cartOverlay = document.querySelector(SELECTORS.cartOverlay);
    const quickAddDrawer = document.querySelector('[data-bod-mobile-quickadd]');
    const quickAddOverlay = document.querySelector(
      '[data-bod-mobile-quickadd-overlay]'
    );

    if (drawer) {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
    }

    if (cartOverlay) {
      cartOverlay.classList.remove('is-open');
    }

    if (quickAddDrawer) {
      quickAddDrawer.classList.remove('is-open');
    }

    if (quickAddOverlay) {
      quickAddOverlay.classList.remove('is-open');
    }

    document.body.classList.remove(
      'bod-cart-open',
      'bod-mobile-quickadd-open',
      'bod-menu-open'
    );
  }

  document.addEventListener('shopify:section:unload', function () {
    resetBodOpenStates();
  });

  document.addEventListener('shopify:section:load', function () {
    resetBodOpenStates();
    initBod();
  });
})();

/* ============================================================
   BOD PDP MOBILE GALLERY + ACCORDIONS + VARIANT SWITCHER
   ============================================================ */

(function () {
  function initPdpMobileGallery(root) {
    var gallery = root.querySelector('[data-bod-pdp-mobile-gallery]');
    if (!gallery) return;

    var track = gallery.querySelector('[data-bod-pdp-mobile-track]');
    var slides = Array.prototype.slice.call(
      gallery.querySelectorAll('[data-bod-pdp-mobile-slide]')
    );
    var dots = Array.prototype.slice.call(
      gallery.querySelectorAll('[data-bod-pdp-mobile-dot]')
    );

    if (!track || !slides.length) return;

    function setActiveDot(index) {
      dots.forEach(function (dot, dotIndex) {
        dot.classList.toggle('is-active', dotIndex === index);
      });
    }

    function getActiveIndex() {
      var scrollLeft = track.scrollLeft;
      var width = track.clientWidth || 1;

      return Math.round(scrollLeft / width);
    }

    var raf = null;

    track.addEventListener(
      'scroll',
      function () {
        if (raf) cancelAnimationFrame(raf);

        raf = requestAnimationFrame(function () {
          setActiveDot(getActiveIndex());
        });
      },
      { passive: true }
    );

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        var slide = slides[index];

        if (!slide) return;

        track.scrollTo({
          left: slide.offsetLeft,
          behavior: 'smooth'
        });

        setActiveDot(index);
      });
    });

    function goToSlide(index) {
      var clamped = Math.max(0, Math.min(index, slides.length - 1));
      var slide = slides[clamped];

      if (!slide) return;

      track.scrollTo({
        left: slide.offsetLeft,
        behavior: 'smooth'
      });

      setActiveDot(clamped);
    }

    var prevBtn = gallery.querySelector('[data-bod-pdp-mobile-prev]');
    var nextBtn = gallery.querySelector('[data-bod-pdp-mobile-next]');

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goToSlide(getActiveIndex() - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goToSlide(getActiveIndex() + 1);
      });
    }
  }

  function initPdpAccordions(root) {
    var accordions = Array.prototype.slice.call(
      root.querySelectorAll('.bod-pdp-acc')
    );

    accordions.forEach(function (acc) {
      var btn = acc.querySelector('[data-bod-pdp-acc-btn]');

      if (!btn) return;

      btn.addEventListener('click', function () {
        var isOpen = acc.classList.toggle('is-open');

        btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });
  }

  function parsePdpVariants(root) {
    var script = root.querySelector('[data-bod-pdp-variants]');

    if (!script) return [];

    try {
      return JSON.parse(script.textContent || '[]');
    } catch (error) {
      console.error(error);
      return [];
    }
  }

  function getSelectedValue(buttons) {
    var active = buttons.find(function (btn) {
      return btn.classList.contains('is-active');
    });

    if (!active) return null;

    return active.getAttribute('data-value') || active.textContent.trim();
  }

  function setButtonActive(buttons, selectedButton) {
    buttons.forEach(function (btn) {
      var isActive = btn === selectedButton;

      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function updatePdpImages(root, imageUrl) {
    if (!imageUrl) return;

    var mainImage = root.querySelector('[data-bod-pdp-main-image]');
    var mobileMainImage = root.querySelector('[data-bod-pdp-mobile-main-image]');
    var desktopImages = Array.prototype.slice.call(
      root.querySelectorAll('[data-bod-pdp-image]')
    );

    if (mainImage) {
      mainImage.src = imageUrl;
      mainImage.srcset = '';
    }

    if (mobileMainImage) {
      mobileMainImage.src = imageUrl;
      mobileMainImage.srcset = '';
    }

    if (desktopImages.length) {
      desktopImages[0].src = imageUrl;
      desktopImages[0].srcset = '';
    }

    var mobileTrack = root.querySelector('[data-bod-pdp-mobile-track]');

    if (mobileTrack) {
      mobileTrack.scrollTo({
        left: 0,
        behavior: 'smooth'
      });
    }

    var dots = Array.prototype.slice.call(
      root.querySelectorAll('[data-bod-pdp-mobile-dot]')
    );

    dots.forEach(function (dot, index) {
      dot.classList.toggle('is-active', index === 0);
    });
  }

  function updatePdpVariant(root, variants, colorButtons, sizeButtons) {
    var selectedColor = getSelectedValue(colorButtons);
    var selectedSize = getSelectedValue(sizeButtons);

    var matchingVariant = variants.find(function (variant) {
      var colorMatches = selectedColor ? variant.color === selectedColor : true;
      var sizeMatches = selectedSize ? variant.size === selectedSize : true;

      return colorMatches && sizeMatches;
    });

    if (!matchingVariant && selectedColor) {
      matchingVariant = variants.find(function (variant) {
        return variant.color === selectedColor;
      });
    }

    if (!matchingVariant) return;

    var colorLabel = root.querySelector('[data-bod-pdp-current-color]');
    var price = root.querySelector('[data-bod-pdp-price]');
    var atc = root.querySelector('[data-bod-pdp-atc]');

    if (colorLabel && matchingVariant.color) {
      colorLabel.textContent = matchingVariant.color;
    }

    if (price && matchingVariant.price) {
      price.textContent = matchingVariant.price;
    }

    if (atc) {
      atc.setAttribute('data-variant-id', matchingVariant.id);

      if (matchingVariant.available) {
        atc.disabled = false;
        atc.textContent = 'ADD TO CART';
      } else {
        atc.disabled = true;
        atc.textContent = 'SOLD OUT';
      }
    }

    updatePdpImages(root, matchingVariant.image);
  }

  function initPdpVariantSwitcher(root) {
    var variants = parsePdpVariants(root);
    var colorButtons = Array.prototype.slice.call(
      root.querySelectorAll('[data-bod-pdp-color]')
    );
    var sizeButtons = Array.prototype.slice.call(
      root.querySelectorAll('[data-bod-pdp-size]')
    );

    if (!variants.length) return;

    colorButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setButtonActive(colorButtons, btn);
        updatePdpVariant(root, variants, colorButtons, sizeButtons);
      });
    });

    sizeButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setButtonActive(sizeButtons, btn);
        updatePdpVariant(root, variants, colorButtons, sizeButtons);
      });
    });

    updatePdpVariant(root, variants, colorButtons, sizeButtons);
  }

  function initPdpAtc() {
    document.addEventListener('click', async function (event) {
      var atc = event.target.closest('[data-bod-pdp-atc]');

      if (!atc) return;

      event.preventDefault();

      var variantId = atc.getAttribute('data-variant-id');

      if (!variantId || atc.disabled) return;

      atc.disabled = true;
      atc.textContent = 'ADDING...';

      try {
        var response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            id: Number(variantId),
            quantity: 1
          })
        });

        if (!response.ok) {
          throw new Error('Could not add product.');
        }

        window.location.href = '/cart';
      } catch (error) {
        console.error(error);
        atc.disabled = false;
        atc.textContent = 'ADD TO CART';
      }
    });
  }

  function initPdpEnhancements() {
    var roots = Array.prototype.slice.call(
      document.querySelectorAll('[data-bod-pdp]')
    );

    roots.forEach(function (root) {
      if (root.dataset.bodPdpEnhanced === 'true') return;

      root.dataset.bodPdpEnhanced = 'true';

      initPdpMobileGallery(root);
      initPdpAccordions(root);
      initPdpVariantSwitcher(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initPdpEnhancements();
      initPdpAtc();
    });
  } else {
    initPdpEnhancements();
    initPdpAtc();
  }

  document.addEventListener('shopify:section:load', initPdpEnhancements);
})();